import { isValid } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { isNumber } from 'lodash-es';

export const convertToDateTime = (dateString: string | number): Date | null => {
    let date: Date = null;

    if (!dateString) return date;

    // check if include time string
    if (isNumber(dateString) || dateString.includes(':')) {
        date = new Date(dateString);
    } else {
        // case that it only include date string
        const localTimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
        date = zonedTimeToUtc(dateString, localTimezone);
    }

    if (isValid(date)) return date;

    return null;
};
